import React from "react";
import {Input, FormGroup, Label, Col, FormFeedback} from 'reactstrap';

const RadioList = ({id, name, description, options, onChange, required, errors}) => {
    return (
        <FormGroup row tag="fieldset" className="mb-2">
            <Col md={4} className="pr-md-1">{description} {!!required && '*'}</Col>
            <Col md={8} className="mt-1">
                {options.map(option => {
                    return (
                        <FormGroup check inline={options.length === 2 || options.length === 3} key={`inputs-${option.id}`} className="mb-2">
                            <Label check className="mr-2">
                                <Input
                                    type="radio"
                                    name={`radio-${name}`}
                                    value={option.id}
                                    onChange={(e) => {
                                        onChange(id, {
                                            [name]: (e.target.value)
                                        });
                                    }}
                                />{" "}
                                {option.name}
                            </Label>
                        </FormGroup>
                    );
                })}
                {!!errors ? <FormFeedback className="d-block">{errors[0]}</FormFeedback> : ''}
            </Col>
        </FormGroup>
    );
};

export default RadioList;
